module.exports = "/images/icon_email.png?4d73d0f782d0e3e379dbaf2900f32c2e";